<template>
  <v-dialog v-model="showDialog" max-width="750px">
    <v-card>
      <v-card-title>
        <h3>{{ $vuetify.t('$vuetify.AdminCategories.deleteHeader') }}</h3>
      </v-card-title>
      <v-card-text>
        <p>
          {{ $vuetify.t('$vuetify.AdminIdeaSpace.deleteAlert') }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="deleteIdeaSpace" class="error">
          {{ $vuetify.t('$vuetify.AdminCategories.deleteConfirm') }}
        </v-btn>
        <v-btn @click="showDialog = false">
          {{ $vuetify.t('$vuetify.AdminCategories.deleteCancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '../../api'

export default {
  name: 'IdeaSpaceDeleteDialog',
  props: {
    show: Boolean,
    ideaSpace: Object
  },
  computed: {
    showDialog: {
      get () {
        return this.show
      },
      set (value) {
        if (value === false) {
          this.$emit('handleClose', value)
        }
      }
    }
  },
  methods: {
    deleteIdeaSpace: function () {
      api.ideaSpace.deleteIdeaSpace(this.ideaSpace.school_id, this.ideaSpace.id).then(res => {
        if (res.status < 400) {
          this.$emit('handleSuccess', true)
        } else {
          this.$emit('handleError', false)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
